import {
  MATCH_RULES_GATING_CRITERION,
  MATCH_RULES_PETS_POLICY_LABEL_KEY,
} from '../../ListingProfileApplicantsMatchRules.constants'

export function getMatchRulesPetsOptions(t) {
  return Object.entries(MATCH_RULES_PETS_POLICY_LABEL_KEY).map(
    ([value, labelKey]) => ({ id: value, label: t(labelKey) })
  )
}

export function getIsMatchRulesHouseholdCriterion(criterionKey) {
  return criterionKey === MATCH_RULES_GATING_CRITERION.household
}

export function getIsMatchRulesPetsCriterion(criterionKey) {
  return criterionKey === MATCH_RULES_GATING_CRITERION.pets
}

export function getIsMatchRulesWbsCriterion(criterionKey) {
  return criterionKey === MATCH_RULES_GATING_CRITERION.wbs
}
